import admin from "firebase-admin";
import { e as error } from "../../../../../../chunks/index2.js";
import { G as GITHUB_USER } from "../../../../../../chunks/private.js";
import { o as octokit } from "../../../../../../chunks/octokit.js";
const GET = async ({ locals }) => {
  if (locals.user) {
    const installerRef = admin.firestore().collection("installers").doc(locals.user.email);
    const installer = (await installerRef.get()).data();
    if (installer?.artifactId) {
      const downloadUrl = await octokit.rest.actions.downloadArtifact({
        owner: GITHUB_USER,
        repo: "glimmr",
        artifact_id: installer?.artifactId,
        archive_format: "zip"
      });
      const response = await fetch(downloadUrl.url);
      return new Response(response.body);
    }
    return error(500, { message: "Installer not ready" });
  }
  return error(403, { message: "Unauthorized" });
};
export {
  GET
};
